import type {CssPropertyEnumCssPropertyType} from '@wix/ambassador-devcenter-v1-component-type-data/types'
import {CSS_PROPERTIES} from '@wix/component-protocol/schema' // eslint-disable-line wix-editor/no-internal-import

export const STYLE_TYPE_MAP: Record<string, CssPropertyEnumCssPropertyType> = {
    // CSS variables
    UnitSizeVar: CSS_PROPERTIES.CSS_PROPERTY_TYPE.length,
    NumberVar: CSS_PROPERTIES.CSS_PROPERTY_TYPE.number,

    // CSS properties
    JustifyContentVar: CSS_PROPERTIES.CSS_PROPERTY_TYPE.justifyContent,
    ItemsAlignmentVar: CSS_PROPERTIES.CSS_PROPERTY_TYPE.alignItems,
    OverflowVar: CSS_PROPERTIES.CSS_PROPERTY_TYPE.overflow
}

// Skip styles that exist on the blocks side but are not yet supported
// by the component protocol specification
export const SKIP_STYLE_LIST = ['PositionTypeVar']
